import { render, staticRenderFns } from "./PrivacyProtocolDemo.vue?vue&type=template&id=b8159da4&scoped=true"
import script from "./PrivacyProtocolDemo.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocolDemo.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocolDemo.vue?vue&type=style&index=0&id=b8159da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8159da4",
  null
  
)

export default component.exports